<template>
  <div
    class="image-modal-wrapper position-fixed align-items-center justify-content-center d-flex position-fixed"
  >
    <div class="modal-inner align-items-center justify-content-center d-flex">
      <div
        class="bm-image-modal-content bg-white px-24 pt-24 pb-26 position-fixed rounded rounded-4 scroller w-100 h-100"
      >
        <div
          class="p-0 border-0 text-end close-icon-wrapper custom-icon"
          @click="closeModal"
        >
          <icon name="close-icon" />
        </div>
        <div class="bm-modal-body border-0 mt-3">
          <h2 class="text-center modal-heading text-dark-gray fs-24 mb-0">Add Audio</h2>
          <div class="tabs-wrapper">
            <div class="tabs-inner">
              <ul class="list-unstyled d-flex flex-row mb-0 mt-18 audiosss">
                <li class="">
                  <tab
                    :id="2"
                    :tab-active="selectedId"
                    title="My computer"
                    @click="selectedId = '2'"
                  />
                </li>
                <li class="">
                  <tab
                    :id="1"
                    :tab-active="selectedId"
                    title="My gallery"
                    @click="selectedId = '1'"
                  />
                </li>
              </ul>
            </div>

            <div class="main-tabs-content mt-20">
              <div v-if="selectedId == 1">
                <div class="text-center">
                  <gallery-audio/>
                </div>
              </div>
              <div
                v-show="selectedId == 2"
                class="file-select px-16">
                <audio-file-select/>
              </div>
              <div v-if="selectedId == 3">
                <stock-audio-box/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="backdrop position-fixed h-100 w-100"
      @click="$store.commit('setDisplayAddAudioModal', false)"
    />
  </div>
</template>

<script>
import Tab from '@/components/Tab/Tab';
import AudioFileSelect from '@/components/AudioFileSelect/AudioFileSelect';
import EventBus from '@/EventBus';
import StockAudioBox from '@/components/StockAudio/StockAudioBox';
import GalleryAudio from '../AudioGallery/GalleryAudio.vue';

export default {
  name:       'AudioModal',
  components: {
    tab:                 Tab,
    'audio-file-select': AudioFileSelect,
    'stock-audio-box':   StockAudioBox,
    'gallery-audio':     GalleryAudio,
  },
  data() {
    return {
      selectedId: '2',
    };
  },
  mounted() {
    EventBus.$on('toggleTabs', this.handleTabClick);
  },
  beforeDestroy() {
    EventBus.$off('toggleTabs', this.handleTabClick);
  },
  methods: {
    handleTabClick(id) {
      this.selectedId = id;
    },
    closeModal() {
      EventBus.$emit('abortAudioUpload');
      this.$store.commit('setDisplayAddAudioModal', false);
    },
  },
};
</script>

<style lang="scss" scoped>
ul.audiosss{
  li {
    width: 50%;
  }
}
</style>
